namespace Ir.Components.Workbook.Widgets.KPIWidget {
    interface IViewModel {
        config: WorkbookConfig;
        widget: any;

        sparkLineOptions: DevExpress.viz.dxSparkline.Properties;
        sparkLineComponent: DevExpress.viz.dxSparkline;
        dispose: Function;

        customTitle: KnockoutComputed<string>;
        icon: KnockoutComputed<string>;
        iconColor: KnockoutComputed<string>;
        color: KnockoutComputed<string>;
        indicator: KnockoutComputed<string>;
        targetColor: KnockoutComputed<string>;
        target: KnockoutComputed<string>;
        variance: KnockoutComputed<string>;
        sparkLineColor: KnockoutComputed<string>;

        percentageValue: KnockoutComputed<number>;
        formattingRuleScale: KnockoutComputed<FormattingRuleScale>;
        itemConfig: KPIConfig;
        result: KPIWidgetResultVM;
    }

    export function getViewModel(this: IViewModel, params: any, componentInfo) {
        let self = this;

        self.config = params.config as WorkbookConfig;
        self.widget = params.widget;

        let widget: KPIWidget = params.widget;
        let itemConfig = widget.itemConfig;
        self.itemConfig = itemConfig;
        let result = widget.result;
        self.result = result;
        widget.set$ReportContent(componentInfo.element);
        widget.setup();

        self.percentageValue = ko.computed(function () {
            let value = 0;
            if (result.targetValue) {
                switch (itemConfig.distanceType()) {
                    case DistanceTypeEnum.ValuePercent100:
                    case DistanceTypeEnum.Percent100:
                        value = ((result.indicatorValue - result.targetValue) / Math.abs(result.targetValue) + 1) * 100;
                        break;
                    case DistanceTypeEnum.ValuePercent:
                    case DistanceTypeEnum.Percent:
                        value = ((result.indicatorValue - result.targetValue) / Math.abs(result.targetValue)) * 100;
                        break;
                    case DistanceTypeEnum.Value:
                        value = result.indicatorValue - result.targetValue;
                        break;
                }
            }
            return value;
        });

        self.formattingRuleScale = ko.computed(function (this: KnockoutObservable<number>) {
            let referenceValue = self.percentageValue();
            let id = this();
            let formattingRule = FormattingRuleService.getFormattingRuleById(id);
            if (!formattingRule) {
                formattingRule = FormattingRuleService.getNewFormattingRule();
            }
            let scales = formattingRule.scales;
            let scale: FormattingRuleScale = null;
            for (var i = 0; i < scales.length; i++) {
                if (referenceValue >= scales[i].minValue) {
                    scale = scales[i];
                }
                else {
                    if (i === 0)
                        scale = scales[i];
                    break;
                }
            }

            return scale;
        }, itemConfig.formattingRule);

        let indicatorMetricName = ko.computed(function (this: KnockoutObservable<number>) {
            let id = this();
            let metric = MappingService.getMetricFieldModel(id);
            let nameValue = "";
            if (metric) {
                nameValue = metric.nodeName;
            }
            return nameValue;
        }, itemConfig.indicatorMetric);

        self.customTitle = ko.computed(function () {
            return replaceBasicHtmlContent(itemConfig.titleText() || indicatorMetricName());
        }, this);
        self.icon = ko.computed(function () {
            let icon = null;
            if (itemConfig.formattingRule() && (itemConfig.targetMetric() !== 0 || itemConfig.comparisonFilter.dateOption() !== ComparisonDateOptionEnum.Manual)) {
                let scale = self.formattingRuleScale();
                if (self.formattingRuleScale()) {
                    icon = "bi-" + self.formattingRuleScale().icon;
                }
            }
            return icon;
        });
        self.iconColor = ko.computed(function () {
            let color = itemConfig.indicatorFontColor() ? itemConfig.indicatorFontColor() : "#000000";

            if (itemConfig.formattingRule() && (itemConfig.targetMetric() !== 0 || itemConfig.comparisonFilter.dateOption() !== ComparisonDateOptionEnum.Manual)) {
                let scale = self.formattingRuleScale();
                if (scale && scale.color && scale.color !== "transparent") {
                    color = scale.color;
                }
            }

            return FormattingRuleService.getColor(color, null);
        });

        self.color = ko.computed(function () {
            let color = itemConfig.indicatorFontColor() ? itemConfig.indicatorFontColor() : "#000000";

            if (itemConfig.formattingRule() && (itemConfig.targetMetric() !== 0 || itemConfig.comparisonFilter.dateOption() !== ComparisonDateOptionEnum.Manual)) {
                let scale = self.formattingRuleScale();
                if (scale && scale.fontColor && scale.fontColor !== "transparent") {
                    color = scale.fontColor;
                }
            }

            return FormattingRuleService.getColor(color, null);
        });

        self.indicator = ko.computed(function () {
            return formatValue(result.indicatorValue || 0, itemConfig, result);
        }, this);

        self.target = ko.computed(function () {
            return formatValue(result.targetValue || 0, itemConfig, result);
        });

        self.targetColor = ko.computed(function () {
            let color = itemConfig.indicatorFontColor() ? itemConfig.indicatorFontColor() : "#000000";
            return color;
        });

        self.variance = ko.computed(function () {
            let value = "";
            switch (itemConfig.distanceType()) {
                case DistanceTypeEnum.Percent100:
                case DistanceTypeEnum.Percent:
                    value = ` (${self.percentageValue().toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%)`;
                    break;
                case DistanceTypeEnum.Value:
                    value = ` (${formatValue(self.percentageValue(), itemConfig, result)})`;
                    break;
                case DistanceTypeEnum.ValuePercent100:
                case DistanceTypeEnum.ValuePercent:
                    {
                        let percent = self.percentageValue().toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        let vl = formatValue(result.indicatorValue - result.targetValue, itemConfig, result);
                        value = ` (${vl} / ${percent}%)`;
                    }
                    break;
            }
            return value;
        });

        self.sparkLineColor = ko.computed(function () {
            let color = itemConfig.indicatorFontColor() ? itemConfig.indicatorFontColor() : "#000000";

            if (itemConfig.formattingRule() && (itemConfig.targetMetric() !== 0 || itemConfig.comparisonFilter.dateOption() !== ComparisonDateOptionEnum.Manual)) {
                let scale = self.formattingRuleScale();
                if (scale && scale.color && scale.color !== "transparent") {
                    color = scale.color;
                }

                if (scale && scale.fontColor && scale.fontColor !== "transparent") {
                    color = scale.fontColor;
                }
            }

            return FormattingRuleService.getColor(color, null);
        });

        this.sparkLineOptions = {
            dataSource: result.trendValues,
            argumentField: 'axisValue',
            valueField: 'indicatorValue',
            lineColor: this.sparkLineColor as any,
            showMinMax: true,
            size: {
                height: itemConfig.trendAxisHeight as any
            },
            margin: {
                top: 0,
                bottom: 0,
                left: 2,
                right: 2
            },
            type: 'area',
            tooltip: {
                enabled: false,
            },
            onInitialized(e) {
                self.sparkLineComponent = e.component;
            }
        };
        this.dispose = ResizeService.createResizeObserverForComponent(componentInfo.element, function () {
            if (self.sparkLineComponent) {
                self.sparkLineComponent.render();
            }
        }, true);
    }

    function formatValue(value, itemConfig: KPIConfig, result: KPIWidgetResultVM) {
        if (value === null || value === undefined)
            return "";

        let format = itemConfig.format() === 1 ? FieldFormatStrEnum.Currency : (itemConfig.format() == 2 ? FieldFormatStrEnum.Numeric : FieldFormatStrEnum.Percentage);
        let scaleSymbol = "";

        if (itemConfig.showLargeNumber() && format !== FieldFormatStrEnum.Percentage) {
            let absValue = Math.abs(value);
            if (absValue > 1000000000) {
                scaleSymbol = "B";
                value = value / 1000000000;
            }
            else
                if (absValue > 1000000) {
                    scaleSymbol = "M";
                    value = value / 1000000;
                }
                else
                    if (absValue > 1000) {
                        scaleSymbol = "K";
                        value = value / 1000;
                    }
        }

        let decimalPlaces = itemConfig.decimalPlaces();
        if (decimalPlaces === -1) {
            decimalPlaces = MappingService.getMetricFieldModel(itemConfig.indicatorMetric()).decimalPlaces;
        }

        const currencySign = itemConfig.accountingStyle() ? "accounting" : "standard";
        let dx = DevExpress as any;
        if (format === FieldFormatStrEnum.Currency)
            value = `${dx.formatHelper.format(value, { style: "currency", currency: result.currencyCode, currencyDisplay: "narrowSymbol", precision: decimalPlaces, currencySign: currencySign })}`;
        else if (format === FieldFormatStrEnum.Numeric)
            value = `${dx.formatHelper.format(value, { style: "decimal", precision: decimalPlaces, currencySign: currencySign })}`;
        else if (format === FieldFormatStrEnum.Percentage)
            value = `${dx.formatHelper.format(value / 100, { style: "percent", precision: decimalPlaces, currencySign: currencySign })}`;

        if (scaleSymbol !== "") {
            if (value.includes(")")) {
                value = value.replace(")", scaleSymbol + ")");
            }
            else {
                value += scaleSymbol;
            }
        }

        return value;
    }
}